import { supertypeClass, property } from '@haventech/amorphic';
import { PartyQuery } from './PartyQuery';
import { Address } from './Address';

@supertypeClass({ toClient: true, toServer: true })
export class PersonQuery extends PartyQuery {
  @property({ length: 40, rule: ['name', 'required'] })
  firstName: string;

  @property({ length: 40, rule: 'name' })
  middleName: string;

  @property({ length: 40, rule: ['name', 'required'] })
  lastName: string;

  @property({ rule: ['email'] })
  email: string;

  @property({ toClient: false, rule: ['SSN'], sensitiveData: true })
  SSN: string;

  @property({ sensitiveData: true })
  dob: Date;

  @property({ getType: () => Address })
  residentialAddress: Address;

  constructor() {
    super();
  }

  static new() {
    return new PersonQuery().init();
  }

  init() {
    super.init();
    return this;
  }

  getMiddleInitial() {
    return this.middleName.substr(0, 1);
  }

  getFullName() {
    return this.firstName + (this.middleName ? ' ' + this.middleName : '') + ' ' + this.lastName;
  }
}
